import forEach from 'lodash/forEach'
import {pathToRegexp as pathRegExp} from 'path-to-regexp'


const initLoginPage = [
  '/app/ultraman/guild/(.*)',
  '/app/star(.*)',
  '/app/medal(.*)',
]

const disableInitLoginPage: Array<string> = []

const disableInitUserPage = [
  '/app/agreement-update',
  '/app/agreement',
  // '/app/ultraman/guild/info'
]

/**
 * 是否需要 弹出登录框 ,默认不需要登录
 * @param pathname {string} path
 */
const isInitLoginPage = (pathname: string) => {
  let res = true;
  // console.log('isInitLoginPage1111111',pathname,disableInitLoginPage)
  forEach(disableInitLoginPage, (reg:string):void|boolean => {
    // console.log('isInitLoginPage1222222',reg,pathname)
    if (pathRegExp(reg, []).test(pathname)) {
      res = false;
      return false;
    }
  })

  // return false

  // @ts-ignore
  if (res === false) {
    return false
  }

  res = false;
  forEach(initLoginPage,(reg:string):void|boolean => {
    if (pathRegExp(reg, []).test(pathname)) {
      res = true;
      return false;
    }
  })

  return res;
}

/**
 * 是否需要 初始化 user 模块，默认初始化
 * @param pathname
 * @returns {boolean}
 */
const isInitUserPage = (pathname: string) => {
  let res = true;
  forEach(disableInitUserPage, (reg:string):void|boolean => {
    if (pathRegExp(reg, []).test(pathname)) {
      res = false;
      return false;
    }
  })

  return res;
}

export default {
  isInitLoginPage,
  isInitUserPage
}
